import { isEmpty } from "lodash";
import { LOCAL_SOURCE_ATLAS_URL } from "./const";

export function getSourceAtlasUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  if (isEmpty(REACT_ENV)) {
    return LOCAL_SOURCE_ATLAS_URL;
  }
  return import.meta.env.VITE_SOURCE_ATLAS_URL || "";
}

export const getSourceAtlasUrlValue = () => {
  return getSourceAtlasUrl();
};
